import React from "react";
import ServicesBox from "./ServicesBox";
import { useAuth } from "../../Store/AuthContext";
import { ServiceFetchData } from "../../APIS/FetchAPIs";

export default function ServiceSectionHome() {
  const { RendomTokenfetch } = useAuth();
  const [ServiceData] = ServiceFetchData(RendomTokenfetch);

  return (
    <>
      <section className="service-section-3 fix section-padding">
        <div className="container">
          <div className="section-title text-center">
            {/* <h5 className="wow fadeInUp">
              <i className="fa fa-angle-double-left" aria-hidden="true"></i> OUR
              SERVICES{" "}
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </h5> */}
            <h2 className="wow fadeInUp aboutSectiontitle" data-wow-delay=".3s">
              Our Services
            </h2>
          </div>
          <div className="row">
            {ServiceData.length > 0
              ? ServiceData.map((service, index) => (
                  <ServicesBox key={index} SerData={service} />
                ))
              : ""}
          </div>
        </div>
      </section>
    </>
  );
}
